import React from 'react';

export const SelectColumnFilter = (filter, options, onChange) => (
  <select
    onChange={(event) => onChange(event.target.value)}
    value={filter ? filter.value : ''}
    style={{ width: '100%' }}
    placeholder='Select'
  >
    {options.map(({ value, label, isHidden = false }) => (
      <option key={label} value={value} hidden={isHidden}>
        {label}
      </option>
    ))}
  </select>
);
